import { render } from "./g-payment_stripe-sepa.vue?vue&type=template&id=55d5a754&ts=true"
import script from "./g-payment_stripe-sepa.vue?vue&type=script&lang=tsx"
export * from "./g-payment_stripe-sepa.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__